import { render } from "./ClusterMembershipEditor.vue?vue&type=template&id=21ae490c"
import script from "./ClusterMembershipEditor.vue?vue&type=script&lang=js"
export * from "./ClusterMembershipEditor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../dashboard-mellow-embed-clipboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__